import {
  GET_INVITED_CHILD_INFO,
  SET_POPUP_STEP,
  SET_POPUP_STATUS,
  UPDATE_REQUEST_STATUS,
  SET_POPUP_LOADING
} from './constants';
import { POPUP_STEPS, REQUEST_STATUSES } from '../constants';

const initialState = {
  status: REQUEST_STATUSES.idle,
  accumulators: [],
  frequentQuestions: [],
  questionsTitle: '',
  isOpen: false,
  step: POPUP_STEPS.disconnect,
  isPopupLoading: false,
};

export default function familyChild(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REQUEST_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case GET_INVITED_CHILD_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case SET_POPUP_STEP:
      return {
        ...state,
        step: action.payload,
      };
    case SET_POPUP_STATUS:
      return {
        ...state,
        isOpen: action.payload,
      };
    case SET_POPUP_LOADING:
      return {
        ...state,
        isPopupLoading: action.payload,
      }
    default:
      return state;
  }
}
